import { Nullable } from 'types/definitions'

/**
 * A promise that can be manually resolved or rejected.
 */
export class DeferredPromise<T> {
  /**
   * Resolve the priomise with a nullable object of the specified type.
   *
   * @param v
   * @returns
   */
  resolve: (value: Nullable<T> | PromiseLike<T>) => void = (v) => v

  /**
   * Reject the promise for any reason.
   *
   * @param v
   * @returns
   */
  reject: (value: any) => void = (v) => v

  /**
   * The promise being deferred.
   */
  promise?: Promise<Nullable<T>>

  constructor() {
    this.reset()
  }

  reset() {
    if (this.promise) {
      this.resolve(null)
    }

    this.promise = new Promise<Nullable<T>>((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }
}
